import { render, staticRenderFns } from "./AuthorisationPage.vue?vue&type=template&id=5253d14d&scoped=true&"
import script from "./AuthorisationPage.vue?vue&type=script&lang=js&"
export * from "./AuthorisationPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorisationPage.vue?vue&type=style&index=0&id=5253d14d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253d14d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5253d14d')) {
      api.createRecord('5253d14d', component.options)
    } else {
      api.reload('5253d14d', component.options)
    }
    module.hot.accept("./AuthorisationPage.vue?vue&type=template&id=5253d14d&scoped=true&", function () {
      api.rerender('5253d14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/AuthorisationPage.vue"
export default component.exports